import React, { Component } from 'react';
import { array, arrayOf, bool, func, object, shape, string, oneOf } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import config from '../../config';
import routeConfiguration from '../../routeConfiguration';
import { findOptionsByFilterLabel, findOptionsForSelectFilter } from '../../util/search';
import {
  LISTING_STATE_PENDING_APPROVAL,
  LISTING_STATE_CLOSED,
  propTypes,
  LISTING_STATE_PUBLISHED,
} from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
} from '../../util/urlHelpers';
import { formatMoney } from '../../util/currency';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import {
  ensureListing,
  ensureOwnListing,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
import { timestampToDate, calculateQuantityFromHours } from '../../util/dates';
import { richText } from '../../util/richText';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/UI.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import {
  Page,
  Modal,
  NamedLink,
  NamedRedirect,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  BookingPanel,
  LayoutWrapperSideNav,
  Button,
  PrimaryButton,
  InlineTextButton,
  CreateGIgDisabledInfo,
} from '../../components';
import { EnquiryForm } from '../../forms';
import { TopbarContainer, NotFoundPage } from '../../containers';

import {
  sendEnquiry,
  setInitialValues,
  fetchTimeSlots,
  fetchTransactionLineItems,
  fetchTransactionId,
  fetchUserTransaction,
} from './ListingPage.duck';
import SectionImages from './SectionImages';
import SectionAvatar from './SectionAvatar';
import SectionHeading from './SectionHeading';
import SectionDescriptionMaybe from './SectionDescriptionMaybe';
import SectionFeaturesMaybe from './SectionFeaturesMaybe';
import SectionReviews from './SectionReviews';
import SectionMapMaybe from './SectionMapMaybe';
import css from './ListingPage.module.css';
import ListingPageCardDetails from '../../components/ListingPageCardDetails/ListingPageCardDetails';

import { listingScheduleType, riskFactorOptions } from '../../marketplace-custom-config';
import classNames from 'classnames';
import {
  closeListing,
  resetCloseListingStatus,
} from '../ManageListingsPage/ManageListingsPage.duck';
import { ReactComponent as EditIcon } from '../../assets/svg/editPen.svg';
import { ReactComponent as CloseIcon } from '../../assets/svg/close.svg';
import { ReactComponent as LeftArrow } from '../../assets/svg/leftArrow.svg';
import { ReactComponent as DotIcon } from '../../assets/svg/threedots.svg';

import moment from 'moment';
import {
  declineAssignedGigs,
  initiateAssignedGigs,
  initiateZeroOrder,
} from '../CheckoutPage/CheckoutPage.duck';
import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import { updateProfile, customUpdateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { removeWorker } from '../../components/PendingAcceptanceWorkerCard/PendingAcceptanceWorkerCard.duck.js';
import RatingAndComment from '../../components/RatingAndComment/RatingAndComment.js';

const MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE = 16;
export const TRANSITION_ASSIGNED_BY_BUSINESS = 'transition/assigned-by-business';
const { UUID } = sdkTypes;

const priceData = (price, intl) => {
  if (price && price.currency === config.currency) {
    const formattedPrice = formatMoney(intl, price);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: `(${price.currency})`,
      priceTitle: `Unsupported currency (${price.currency})`,
    };
  }
  return {};
};

export class ListingPageComponent extends Component {
  constructor(props) {
    super(props);
    const { enquiryModalOpenForListingId, params } = props;
    this.state = {
      pageClassNames: [],
      imageCarouselOpen: false,
      enquiryModalOpen: enquiryModalOpenForListingId === params.id,
      listingMenuOpen: null,
      // bookingCompleteModalOpen: false,
      misAcceptModal: false,
      vacancyFullModal: false,
      noBankDetailsModal: false,
      bookingInProgress: false,
      alreadyApplied: null,
      transactionId: null,
      cancelBooking: false,
      cancelLoading: false,
      dotIconDiv: false,
      showClosedModal: false,
      closeListing: null,
      jobCategoryOptions: findOptionsForSelectFilter('category', this.props.filterConfig),
      jobSubCategoryOptions: findOptionsByFilterLabel('Subcategory', this.props.filterConfig),
      vacanyFullMsgId: 'ListingPage.vancancyModalDescForApply',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDeclineAssigned = this.handleDeclineAssigned.bind(this);
    this.onContactUser = this.onContactUser.bind(this);
    this.onSubmitEnquiry = this.onSubmitEnquiry.bind(this);
    this.onToggleMenu = this.onToggleMenu.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleBookingInProgress = this.handleBookingInProgress.bind(this);
  }
  onToggleMenu(listing) {
    this.setState({ listingMenuOpen: listing });
  }

  handleBookingInProgress = val => {
    this.setState({ bookingInProgress: val });
  };

  handleSubmit(values) {
    const {
      history,
      getListing,
      params,
      callSetInitialValues,
      onInitializeCardPaymentData,
      onInitiateZeroOrder,
      oninitiateAssignedGigs,
      currentUser,
      onUpdateProfile,
      assignedStatus,
    } = this.props;

    const hasPayoutDetails =
      typeof currentUser.stripeAccount?.attributes?.stripeAccountId === 'string' &&
      currentUser.stripeAccount.attributes.stripeAccountId;

    if (!hasPayoutDetails) {
      this.setState({ noBankDetailsModal: true, bookingInProgress: false });
      return;
    }

    const listingId = new UUID(params.id);
    const listing = getListing(listingId);
    const scheduleType = listing?.attributes?.publicData?.scheduleType;

    let { startDate, startTime } =
      scheduleType === listingScheduleType.oneTime
        ? listing?.attributes?.publicData?.oneTimeScheduleList?.[0]
        : listing?.attributes?.publicData?.recurringScheduleList?.[0];

    let { endDate, endTime } =
      scheduleType === listingScheduleType.recurring &&
      listing?.attributes?.publicData?.recurringScheduleList?.[0];

    // calculating end date for oneTime

    if (scheduleType === listingScheduleType.oneTime) {
      const startTimeHour = parseInt(startTime?.hours?.value, 10);
      const endTimeHour = parseInt(
        listing?.attributes?.publicData?.oneTimeScheduleList?.[0].endTime?.hours?.value
      );

      const sDate = moment(startDate?.date).set({
        hour: startTime?.hours?.value,
        minute: startTime?.min?.value,
      });

      let eDate = moment(startDate?.date).set({
        hour: listing?.attributes?.publicData?.oneTimeScheduleList?.[0].endTime?.hours?.value,
        minute: listing?.attributes?.publicData?.oneTimeScheduleList?.[0].endTime?.min?.value,
      });

      if (startTimeHour > endTimeHour) {
        eDate.add(1, 'day');
      }
      const momentObject = moment(eDate);

      const formattedDate = momentObject.format('YYYY-MM-DDTHH:mm:ssZ');

      endDate = { date: formattedDate };
    }

    const timezoneOffset = moment(startDate?.date).utcOffset();

    // Construct start and end moments
    const startMoment = moment(startDate?.date).set({
      hours: parseInt(startTime?.hours?.value, 10),
      minutes: parseInt(startTime?.min?.value, 10),
      seconds: 0,
      milliseconds: 0,
    });

    const endMoment = moment(endDate ? endDate?.date : startDate?.date).set({
      hours: parseInt(endTime?.hours?.value, 10),
      minutes: parseInt(endTime?.min?.value, 10),
      seconds: 0,
      milliseconds: 0,
    });

    const [jobCategory] = listing.attributes.publicData.jobCategories;
    const { category, subCategory } = jobCategory;
    const listingCate = this.state.jobCategoryOptions.find(cate => cate.key === category);
    const listingSubCate = this.state.jobSubCategoryOptions[`${category}Subcategory`].find(
      subCate => subCate.key === subCategory
    );

    const protectedData = {
      job: { cate: listingCate, subCate: listingSubCate },
      scheduleType,
    };

    // const [jobCategory] = listing.attributes.jobCategories;
    // const {category,subCategory}=jobCategory
    // const listingCate=this.state.jobCategoryOptions.find(cate=>cate.key === category)
    // const listingSubCate=this.state.jobSubCategoryOptions[`${category}Subcategory`].find(subCate=>subCate.key === subCategory)
    // Convert to UTC
    const startUtc = startMoment.utcOffset(timezoneOffset).toDate();
    const endUtc = endMoment.utcOffset(timezoneOffset).toDate();

    const bookingStartTime = startUtc;
    const bookingEndTime = endUtc;
    // const { ...restOfValues } = values;
    // const bookingStart = timestampToDate(bookingStartTime);
    // const bookingEnd = timestampToDate(bookingEndTime);

    const bookingData = {
      // quantity: calculateQuantityFromHours(bookingStart, bookingEnd),
      quantity: 1,
      workerId: this.props.currentUser?.id?.uuid,
      // ...restOfValues,
    };

    const initialValues = {
      listing,
      bookingData,
      bookingDates: {
        bookingStart: bookingStartTime,
        bookingEnd: bookingEndTime,
      },
      protectedData,
      confirmPaymentError: null,
    };
    const saveToSessionStorage = !this.props.currentUser;

    const routes = routeConfiguration();
    // Customize checkout page state with current listing and selected bookingDates
    const { setInitialValues } = findRouteByRouteName('CheckoutPage', routes);
    callSetInitialValues(setInitialValues, initialValues, saveToSessionStorage);
    const gigVacancyStatusUrl = `${apiBaseUrl()}/api/gig-vacancy-status/${params.id}`;
    const gigVacancyUpdateUrl = `${apiBaseUrl()}/api/gig-vacancy/${params.id}`;
    const isAssignedWork = assignedStatus === TRANSITION_ASSIGNED_BY_BUSINESS;
    const transitionFunction = isAssignedWork ? oninitiateAssignedGigs : onInitiateZeroOrder;
    const vancanyStatusPromise = isAssignedWork
      ? axios.patch(gigVacancyStatusUrl, {})
      : Promise.resolve();

    vancanyStatusPromise
      .then(() => transitionFunction(initialValues))
      .then(async res => {
        const appliedListingId = params.id;
        const profile = {
          id: currentUser.id.uuid,
          publicData: {},
        };

        const updatedValue = { profile, acceptedListing: appliedListingId };
        await Promise.all([
          isAssignedWork
            ? axios.post(`${apiBaseUrl()}/api/updateWorker`, updatedValue)
            : Promise.resolve(),
          axios.get(`${apiBaseUrl()}/api/apply-job/${params.id}`, { withCredentials: true }),
        ]);
        const finalBody = {
          initialValues,
          currentUser: this.props?.currentUser,
          status: isAssignedWork ? 'accepted' : 'pending',
          transactionId: res.data.id.uuid,
        };
        await axios.post(`${apiBaseUrl()}/api/timeStatement/create`, finalBody).then(async res => {
          let params = {
            appliedListingId: currentUser?.attributes?.profile?.publicData?.appliedListingId
              ? [
                ...currentUser?.attributes?.profile?.publicData?.appliedListingId,
                appliedListingId,
              ]
              : [appliedListingId],
          };
          const profile = {
            publicData: { ...params },
          };

          const updatedValue = profile;
          onUpdateProfile(updatedValue);
        });

        history.push(
          createResourceLocatorString('OrderDetailsPage', routes, { id: res.data.id.uuid }, {})
        );
      })
      .catch(err => {
        const canApply = err?.response?.data?.canApply;
        if (typeof canApply === 'boolean' && !canApply) {
          this.setState({
            vacancyFullModal: true,
            bookingInProgress: false,
            vacanyFullMsgId: isAssignedWork
              ? 'ListingPage.vancancyModalDescForAccept'
              : 'ListingPage.vancancyModalDescForApply',
          });
        } else {
          this.setState({ bookingInProgress: false });
          axios.patch(gigVacancyUpdateUrl, {});
          if (isAssignedWork) {
            this.setState({ misAcceptModal: true });
          }
        }
      });

    // Clear previous Stripe errors from store if there is any
    // onInitializeCardPaymentData();

    // Redirect to CheckoutPage
    // history.push(
    //   createResourceLocatorString(
    //     'OrderDetailsPage',
    //     routes,
    //     { id: listing.id.uuid,  },
    //     {}
    //   )
    // );
  }

  handleDeclineAssigned(values) {
    const {
      history,
      getListing,
      params,
      onDeclineAssignedJob,
      currentUser,
      assignedStatus,
    } = this.props;
    const listingId = new UUID(params.id);
    const listing = getListing(listingId);

    return onDeclineAssignedJob({
      listingId,
      workerId: currentUser.id.uuid,
    })
      .then(res => {
        if (assignedStatus === TRANSITION_ASSIGNED_BY_BUSINESS) {
          const reqParams = {
            workerId: currentUser.id.uuid,
            gigId: params.id,
          };
          const removeAssignedGigurl = `${apiBaseUrl()}/api/user/removeAssignedGig`;
          const removeAwaitingAcceptanceurl = `${apiBaseUrl()}/api/user/removeAwaitingAcceptance`;
          const promises = [
            axios.post(removeAssignedGigurl, reqParams),
            // axios.post(removeAwaitingAcceptanceurl, reqParams),
          ];
          Promise.all(promises);
        }
      })
      .catch(err => {
        this.setState({ misAcceptModal: true });
        throw err;
      });
  }

  onContactUser() {
    const { currentUser, history, callSetInitialValues, params, location } = this.props;

    if (!currentUser) {
      const state = { from: `${location.pathname}${location.search}${location.hash}` };

      // We need to log in before showing the modal, but first we need to ensure
      // that modal does open when user is redirected back to this listingpage
      callSetInitialValues(setInitialValues, { enquiryModalOpenForListingId: params.id });

      // signup and return back to listingPage.
      history.push(createResourceLocatorString('SignupPage', routeConfiguration(), {}, {}), state);
    } else {
      this.setState({ enquiryModalOpen: true });
    }
  }

  onSubmitEnquiry(values) {
    const { history, params, onSendEnquiry } = this.props;
    const routes = routeConfiguration();
    const listingId = new UUID(params.id);
    const { message } = values;

    onSendEnquiry(listingId, message.trim())
      .then(txId => {
        this.setState({ enquiryModalOpen: false });

        // Redirect to OrderDetailsPage
        history.push(
          createResourceLocatorString('OrderDetailsPage', routes, { id: txId.uuid }, {})
        );
      })
      .catch(() => {
        // Ignore, error handling in duck file
      });
  }
  componentDidUpdate(prevProps, prevState) {
    const { currentUser, getListing, params, onFetchTransactionId } = this.props;
    const listingId = new UUID(params.id);
    const currentListing = getListing(listingId);

    if (prevState.alreadyApplied === null && !!currentUser && !!currentListing) {
      const alreadyApplied =
        currentListing?.attributes?.publicData?.appliedCust &&
        currentListing?.attributes?.publicData?.appliedCust?.includes(currentUser?.id?.uuid);

      this.setState({ alreadyApplied }, () => {
        if (prevState.transactionId === null && !!currentUser && !!currentListing) {
          onFetchTransactionId(listingId);
        }
      });
    }
  }
  async handleCancel() {
    //check cancellation remaining time
    this.setState({ cancelLoading: true });

    const {
      params,
      getListing,
      currentUser,
      listingUserTx,
      onfetchUserTransaction,
      onUpdateProfile,
    } = this.props;
    const listingId = new UUID(params.id);
    const listing = getListing(listingId);
    let { startDate, startTime } =
      listing?.attributes?.publicData?.scheduleType === listingScheduleType.oneTime
        ? listing?.attributes?.publicData?.oneTimeScheduleList?.[0]
        : listing?.attributes?.publicData?.recurringScheduleList?.[0];
    const author = listing?.author;
    const companyName = author?.attributes?.profile?.publicData?.companyName;
    const businessName = author?.attributes?.displayName;
    const workerCustomId = currentUser?.attributes?.profile?.publicData.customId;
    const workerName = currentUser?.attributes?.displayName;
    const currMoment = moment();
    const startMoment = moment(startDate?.date).set({
      hours: parseInt(startTime?.hours?.value, 10),
      minutes: parseInt(startTime?.min?.value, 10),
      seconds: 0,
      milliseconds: 0,
    });
    if (currMoment.isSameOrAfter(startMoment)) {
      this.setState({ cancelLoading: false });

      return null;
    }
    const hoursDifference = startMoment.diff(currMoment, 'minutes') / 60;
    const isAfter24Hours = hoursDifference >= 24;
    const url = `${apiBaseUrl()}/api/user/cancelledByWorker`;
    const apiBody = {
      workerId: currentUser?.id?.uuid,
      listingId: listing.id.uuid,
      isAfter24Hours,
      txId: listingUserTx.id.uuid,
      businessId: listing?.author?.id?.uuid,
      companyName,
      businessName,
      workerCustomId,
      workerName,
      transitionName: listingUserTx.attributes.lastTransition,
      cancelDate: new Date(),
    };

    const cancelBooking = await axios.post(url, apiBody, { withCredentials: true });
    const appliedListingId = currentUser?.attributes?.profile?.publicData?.appliedListingId || [];
    const newAppliedListingId = appliedListingId.filter(id => id !== params.id);
    await onUpdateProfile({ publicData: { appliedListingId: newAppliedListingId } });
    this.setState({
      cancelLoading: false,
      cancelBooking: false,
      bookingInProgress: false,
    });
    await onfetchUserTransaction(listing.id.uuid);

    return cancelBooking;
  }

  setShowCloseModal = isOpen => {
    const { onResetCloseListingStatus } = this.props;
    if (!isOpen) {
      onResetCloseListingStatus();
    }
    this.setState({ showClosedModal: isOpen });
  };

  handleCloseListing = listing => {
    this.setState({ showClosedModal: true, closeListing: listing });
  };
  acceptListingClose = e => {
    e.preventDefault();
    const { onCloseListing, history } = this.props;
    const listingId = this.state.closeListing.id.uuid;
    onCloseListing(listingId)
      .then(() => {
        this.setShowCloseModal(false);
        history.push(
          createResourceLocatorString('ManageListingsPage', routeConfiguration(), {}, {})
        );
      })
      .catch(e => { });
  };

  goToPayoutPage = () => {
    const { history } = this.props;
    this.setState({ noBankDetailsModal: false });
    history.push(createResourceLocatorString('StripePayoutPage', routeConfiguration()));
  };

  render() {
    const {
      unitType,
      isAuthenticated,
      currentUser,
      getListing,
      getOwnListing,
      intl,
      onManageDisableScrolling,
      onFetchTimeSlots,
      params: rawParams,
      location,
      scrollingDisabled,
      showListingError,
      reviews,
      fetchReviewsError,
      sendEnquiryInProgress,
      sendEnquiryError,
      monthlyTimeSlots,
      filterConfig,
      onFetchTransactionLineItems,
      lineItems,
      fetchLineItemsInProgress,
      fetchLineItemsError,
      userNativeLang,
      history,
      openingListing,
      closingListing,
      onCloseListing,
      closingListingError,
      closeListingInProgress,
      onUpdateProfile,
      onCustomUpdateProfile,
      listingTransactionId,
      assignedStatus,
      listingUserTx,
      stripeAccount,
      fetchStripeAccountError,
      stripeAccountFetched,
      btnLoading,
      onRemoveWorker,
      workerBlockedTimeslots,
    } = this.props;

    const userTxLastTransition = listingUserTx?.attributes?.lastTransition || '';
    const isProvider = currentUser?.attributes?.profile?.publicData?.isProvider;

    const listingId = new UUID(rawParams.id);
    const currentUserId = currentUser?.id?.uuid;
    const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
    const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
    const currentListing =
      isPendingApprovalVariant || isDraftVariant || isProvider
        ? ensureOwnListing(getOwnListing(listingId))
        : ensureListing(getListing(listingId));

    const listingSlug = rawParams.slug || createSlug(currentListing.attributes.title || '');
    const params = { slug: listingSlug, ...rawParams };
    const authorAvailable = currentListing && currentListing.author;
    const userAndListingAuthorAvailable = !!(currentUser && authorAvailable);
    const listingType = isDraftVariant
      ? LISTING_PAGE_PARAM_TYPE_DRAFT
      : LISTING_PAGE_PARAM_TYPE_EDIT;
    const listingTab = isDraftVariant ? 'photos' : 'description';

    const isApproved =
      currentListing.id && currentListing.attributes.state !== LISTING_STATE_PENDING_APPROVAL;

    const pendingIsApproved = isPendingApprovalVariant && isApproved;

    // If a /pending-approval URL is shared, the UI requires
    // authentication and attempts to fetch the listing from own
    // listings. This will fail with 403 Forbidden if the author is
    // another user. We use this information to try to fetch the
    // public listing.
    const pendingOtherUsersListing =
      (isPendingApprovalVariant || isDraftVariant) &&
      showListingError &&
      showListingError.status === 403;
    const shouldShowPublicListingPage = pendingIsApproved || pendingOtherUsersListing;

    if (shouldShowPublicListingPage) {
      return <NamedRedirect name="ListingPage" params={params} search={location.search} />;
    }

    const {
      description = '',
      geolocation = null,
      price = null,
      title = '',
      publicData,
      privateData = {},
      state,
    } = currentListing.attributes;
    const isOwnPublishedListing = !!(
      isProvider &&
      userAndListingAuthorAvailable &&
      currentListing.type === 'ownListing' &&
      ['published', 'closed'].includes(state) &&
      currentUserId === currentListing?.author?.id?.uuid &&
      privateData
    );
    const assignedWorkers = isOwnPublishedListing ? privateData.assignedWorkers || [] : [];
    const appliedWorkers = isOwnPublishedListing ? privateData.appliedWorkers || [] : [];
    const canceledWorkers = isOwnPublishedListing ? privateData.canceledWorkers || [] : [];
    const hasWorkers = assignedWorkers.length > 0 || appliedWorkers.length > 0;

    //check already appied or not
    //  const alreadyApplied =
    //    publicData?.appliedCust && publicData?.appliedCust?.includes(currentUser?.id?.uuid);

    const richTitle = (
      <span>
        {richText(title, {
          longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE,
          longWordClass: css.longWord,
        })}
      </span>
    );

    const bookingTitle = (
      <FormattedMessage id="ListingPage.bookingTitle" values={{ title: richTitle }} />
    );

    const topbar = <TopbarContainer />;

    if (showListingError && showListingError.status === 404) {
      // 404 listing not found

      return <NotFoundPage />;
    } else if (showListingError) {
      // Other error in fetching listing

      const errorTitle = intl.formatMessage({
        id: 'ListingPage.errorLoadingListingTitle',
      });

      return (
        <Page title={errorTitle} scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.errorText}>
                <FormattedMessage id="ListingPage.errorLoadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    } else if (!currentListing.id) {
      // Still loading the listing

      const loadingTitle = intl.formatMessage({
        id: 'ListingPage.loadingListingTitle',
      });

      return (
        <Page title={loadingTitle} scrollingDisabled={scrollingDisabled}>
          <LayoutSingleColumn className={css.pageRoot}>
            <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
            <LayoutWrapperMain>
              <p className={css.loadingText}>
                <FormattedMessage id="ListingPage.loadingListingMessage" />
              </p>
            </LayoutWrapperMain>
            <LayoutWrapperFooter>
              <Footer />
            </LayoutWrapperFooter>
          </LayoutSingleColumn>
        </Page>
      );
    }

    const handleViewPhotosClick = e => {
      // Stop event from bubbling up to prevent image click handler
      // trying to open the carousel as well.
      e.stopPropagation();
      this.setState({
        imageCarouselOpen: true,
      });
    };

    const isOwnListing =
      userAndListingAuthorAvailable && currentListing.author.id.uuid === currentUser.id.uuid;
    const showContactUser = authorAvailable && (!currentUser || (currentUser && !isOwnListing));

    const currentAuthor = authorAvailable ? currentListing.author : null;
    const ensuredAuthor = ensureUser(currentAuthor);

    // When user is banned or deleted the listing is also deleted.
    // Because listing can be never showed with banned or deleted user we don't have to provide
    // banned or deleted display names for the function
    const authorDisplayName = userDisplayNameAsString(ensuredAuthor, '');

    const { formattedPrice, priceTitle } = priceData(price, intl);

    const handleBookingSubmit = values => {
      const isCurrentlyClosed = currentListing.attributes.state === LISTING_STATE_CLOSED;
      if (isOwnListing || isCurrentlyClosed) {
        window.scrollTo(0, 0);
        if (isCurrentlyClosed) {
          this.setState({ misAcceptModal: true, bookingInProgress: false });
        }
      } else {
        this.handleSubmit(values);
      }
    };

    const listingImages = (listing, variantName) =>
      (listing.images || [])
        .map(image => {
          const variants = image.attributes.variants;
          const variant = variants ? variants[variantName] : null;

          // deprecated
          // for backwards combatility only
          const sizes = image.attributes.sizes;
          const size = sizes ? sizes.find(i => i.name === variantName) : null;

          return variant || size;
        })
        .filter(variant => variant != null);

    const facebookImages = listingImages(currentListing, 'facebook');
    const twitterImages = listingImages(currentListing, 'twitter');
    const schemaImages = JSON.stringify(facebookImages.map(img => img.url));
    const siteTitle = config.siteTitle;
    const schemaTitle = intl.formatMessage(
      { id: 'ListingPage.schemaTitle' },
      { title, price: formattedPrice, siteTitle }
    );

    const hostLink = (
      <NamedLink
        className={css.authorNameLink}
        name="ListingPage"
        params={params}
        to={{ hash: '#host' }}
      >
        {authorDisplayName}
      </NamedLink>
    );

    const yogaStylesOptions = findOptionsForSelectFilter('yogaStyles', filterConfig);
    const certificateOptions = findOptionsForSelectFilter('certificate', filterConfig);

    const jobCategoryOptions = this.state.jobCategoryOptions;

    const publishedDate = currentListing?.attributes?.publicData?.gigPublishedDate;
    const descriptionListing = jobCategoryOptions.filter(f =>
      currentListing?.attributes?.publicData.jobCategories.find(m => m.category === f.value)
    )[0].label[userNativeLang];
    const RiskFactorOptions = riskFactorOptions.filter(f =>
      currentListing?.attributes?.publicData?.RiskFactorDesc?.find(m => m.key === f.key)
    );
    const listingRiskFactors = currentListing?.attributes?.publicData?.RiskFactorDesc;
    const actionsInProgressListingId = openingListing || closingListing;
    const gigId = currentListing?.attributes?.publicData?.gigId || 'G - 123456';
    const gigStartDate = currentListing?.attributes?.publicData?.gigStartDate;
    const gigEndDate = currentListing?.attributes?.publicData?.gigEndDate;
    const isDateClosable = gigStartDate && gigEndDate ? moment().isBefore(gigStartDate) : true;
    const shouldClose =
      currentListing?.attributes?.state === LISTING_STATE_PUBLISHED &&
      currentListing?.attributes.state !== LISTING_STATE_CLOSED &&
      isDateClosable;
    const isListingClosed = currentListing?.attributes.state === LISTING_STATE_CLOSED;

    return (
      <Page
        title={schemaTitle}
        scrollingDisabled={scrollingDisabled}
        author={authorDisplayName}
        description={description}
        facebookImages={facebookImages}
        twitterImages={twitterImages}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'ItemPage',
          description: description,
          name: schemaTitle,
          image: schemaImages,
        }}
      >
        <LayoutSingleColumn className={classNames(css.pageRoot, css.Listingpagewrap)}>
          <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
          <LayoutWrapperMain>
            {/* <Modal
              id="ListingPage.misAccept"
              contentClassName={css.enquiryModalContent}
              isOpen={isAuthenticated && this.state.misAcceptModal}
              onClose={() => {
                this.setState({
                  misAcceptModal: false,
                  bookingInProgress: false,
                });
              }}
              onManageDisableScrolling={onManageDisableScrolling}
              containerClassName={css.invoiceModal}
            >
              <div className={css.appliedModalDiv}>
                <div className={css.modalTitle}>
                  <FormattedMessage id="ListingPage.misAcceptModalTitle" />
                </div>
                <div className={css.modalDesc}>
                  <FormattedMessage id="ListingPage.misAcceptModalDesc" />
                </div>

                <Button
                  type="button"
                  className={css.submitButton}
                  onClick={() =>
                    this.setState({
                      misAcceptModal: false,
                      bookingInProgress: false,
                    })
                  }
                >
                  <FormattedMessage id="ContactDetailsForm.TurnOnAuth" />
                </Button>
              </div>
            </Modal> */}

            <div className={css.totoalWrapperListingPage}>
              <div className={css.ListingTopWrap}>
                <div
                  className={css.jobDetails}
                  onClick={() =>
                  // history.goBack()
                  {
                    isProvider
                      ? history.push(
                        createResourceLocatorString(
                          'ManageListingsPage',
                          routeConfiguration(),
                          {},
                          {}
                        )
                      )
                      : history.length > 0
                        ? history.goBack()
                        : history.replace(
                          createResourceLocatorString(
                            'WorkerDashboardPage',
                            routeConfiguration(),
                            {}
                          )
                        );
                  }
                  }
                >
                  <LeftArrow />
                  <FormattedMessage id="ListingCard.jobDetails" />
                </div>
                {isProvider ? (
                  <div className={css.editAndCloseDiv}>
                    {hasWorkers || isListingClosed ? null : (
                      <CreateGIgDisabledInfo
                        gigCreationEnabledChildren={
                          <button
                            className={css.editDiv}
                            onClick={() => {
                              const editParams = {
                                id: listingId.uuid,
                                slug: listingSlug.toString(),
                                type: listingType,
                                tab: listingTab,
                              };

                              history.push(
                                createResourceLocatorString(
                                  'EditListingPage',
                                  routeConfiguration(),
                                  editParams
                                )
                              );
                            }}
                          >
                            <EditIcon className={css.editPenIcon} />
                            <FormattedMessage id="EditListingCard.editjob" />
                          </button>
                        }
                        gigCreationDisabledChildren={
                          <div className={css.editDiv}>
                            <EditIcon className={css.editPenIcon} />
                            <FormattedMessage id="EditListingCard.editjob" />
                          </div>
                        }
                        popupId={'ListingPage.edit'}
                      />
                    )}

                    {shouldClose ? (
                      <CreateGIgDisabledInfo
                        gigCreationEnabledChildren={
                          <button
                            className={css.cancelDiv}
                            onClick={event => {
                              event.preventDefault();
                              event.stopPropagation();
                              if (!actionsInProgressListingId) {
                                this.onToggleMenu(null);
                                this.setState({
                                  showClosedModal: true,
                                  closeListing: currentListing,
                                });
                              }
                            }}
                          >
                            {' '}
                            <CloseIcon className={css.CrossIcon} />
                            <FormattedMessage id="EditListingCard.closejob" />
                          </button>
                        }
                        gigCreationDisabledChildren={
                          <div className={css.cancelDiv}>
                            {' '}
                            <CloseIcon className={css.CrossIcon} />
                            <FormattedMessage id="EditListingCard.closejob" />
                          </div>
                        }
                        popupId={'ListingPage.close'}
                      />
                    ) : null}
                    <div className={css.CardMenu}>
                      <DotIcon
                        onClick={e => {
                          e.preventDefault();
                          this.setState({ dotIconDiv: !this.state.dotIconDiv });
                        }}
                      />
                      <>
                        {this.state.dotIconDiv ? (
                          <div className={css.mobEditAndCloseDiv}>
                            {hasWorkers || isListingClosed ? null : (
                              <CreateGIgDisabledInfo
                                gigCreationEnabledChildren={
                                  <button
                                    className={css.MobeditDiv}
                                    onClick={() => {
                                      const editParams = {
                                        id: listingId.uuid,
                                        slug: listingSlug.toString(),
                                        type: listingType,
                                        tab: listingTab,
                                      };

                                      history.push(
                                        createResourceLocatorString(
                                          'EditListingPage',
                                          routeConfiguration(),
                                          editParams
                                        )
                                      );
                                    }}
                                  >
                                    <EditIcon className={css.editPenIcon} />
                                    <FormattedMessage id="EditListingCard.editjob" />
                                  </button>
                                }
                                gigCreationDisabledChildren={
                                  <div className={css.MobeditDiv}>
                                    <EditIcon className={css.editPenIcon} />
                                    <FormattedMessage id="EditListingCard.editjob" />
                                  </div>
                                }
                                popupId={'ListingPage.edit'}
                              />
                            )}
                            {shouldClose ? (
                              <CreateGIgDisabledInfo
                                gigCreationEnabledChildren={
                                  <button
                                    className={css.MobcancelDiv}
                                    onClick={event => {
                                      event.preventDefault();
                                      event.stopPropagation();
                                      if (!actionsInProgressListingId) {
                                        this.onToggleMenu(null);
                                        onCloseListing(currentListing.id);
                                      }
                                      history.push(
                                        createResourceLocatorString(
                                          'ManageListingsPage',
                                          routeConfiguration(),
                                          {},
                                          {}
                                        )
                                      );
                                    }}
                                  >
                                    {' '}
                                    <CloseIcon className={css.CrossIcon} />
                                    <FormattedMessage id="EditListingCard.closejob" />
                                  </button>
                                }
                                gigCreationDisabledChildren={
                                  <div className={css.MobcancelDiv}>
                                    {' '}
                                    <CloseIcon className={css.CrossIcon} />
                                    <FormattedMessage id="EditListingCard.closejob" />
                                  </div>
                                }
                                popupId={'ListingPage.close'}
                              />
                            ) : null}
                          </div>
                        ) : null}
                      </>
                    </div>
                  </div>
                ) : null}
              </div>
              <div className={css.contentContainer}>
                {/* <SectionAvatar user={currentAuthor} params={params} /> */}

                <div className={css.mainContent}>
                  <ListingPageCardDetails
                    currentUser={currentUser}
                    listing={currentListing}
                    isProvider={isProvider}
                    alreadyApplied={this.state.alreadyApplied}
                    history={history}
                    listingTransactionId={listingTransactionId}
                    userTxLastTransition={userTxLastTransition}
                    assignedWorkers={assignedWorkers}
                    appliedWorkers={appliedWorkers}
                    canceledWorkers={canceledWorkers}
                    isOwnPublishedListing={isOwnPublishedListing}
                    onRemoveWorker={onRemoveWorker}
                    intl={intl}
                    onManageDisableScrolling={onManageDisableScrolling}
                  />
                </div>
                <div
                  className={classNames(css.mainContentforbooking, {
                    [css.mainContentforbookingWorker]: !isProvider,
                  })}
                >
                  <BookingPanel
                    className={css.bookingPanel}
                    listing={currentListing}
                    isOwnListing={isOwnListing}
                    unitType={unitType}
                    onSubmit={handleBookingSubmit}
                    title={bookingTitle}
                    authorDisplayName={authorDisplayName}
                    onManageDisableScrolling={onManageDisableScrolling}
                    monthlyTimeSlots={monthlyTimeSlots}
                    onFetchTimeSlots={onFetchTimeSlots}
                    onFetchTransactionLineItems={onFetchTransactionLineItems}
                    lineItems={lineItems}
                    fetchLineItemsInProgress={fetchLineItemsInProgress}
                    fetchLineItemsError={fetchLineItemsError}
                    isProvider={isProvider}
                    editParams={{
                      id: listingId.uuid,
                      slug: listingSlug,
                      type: listingType,
                      tab: listingTab,
                    }}
                    currentUser={currentUser}
                    handleBookingInProgress={this.handleBookingInProgress}
                    bookingInProgress={this.state.bookingInProgress}
                    onUpdateProfile={onUpdateProfile}
                    onCustomUpdateProfile={onCustomUpdateProfile}
                    alreadyApplied={this.state.alreadyApplied}
                    listingAuthor={ensuredAuthor}
                    handleDeclineAssigned={this.handleDeclineAssigned}
                    assignedStatus={assignedStatus}
                    handleCancel={this.handleCancel}
                    listingUserTx={listingUserTx}
                    userTxLastTransition={userTxLastTransition}
                    setCancelState={bool => this.setState({ cancelBooking: bool })}
                    stripeAccount={stripeAccount}
                    fetchStripeAccountError={fetchStripeAccountError}
                    stripeAccountFetched={stripeAccountFetched}
                    btnLoading={btnLoading}
                    workerBlockedTimeslots={workerBlockedTimeslots}
                  />
                </div>
              </div>
              {listingRiskFactors !== undefined && listingRiskFactors.length > 0 ? (
                <div className={css.riskcontainer}>
                  <span className={css.riskFactorSpan}>
                    <FormattedMessage id="listingpage.riskFactor" />
                    {/* {listingRiskFactors.length > 1 ? 's' : null} */}
                  </span>
                  <div className={css.riskTotal}>
                    {RiskFactorOptions?.map(m => {
                      return (
                        <div className={css.risk} key={m.key}>
                          <div className={css.riskHeading}>{m?.label[userNativeLang]}</div>
                          <div className={css.safetyMeasure}>
                            <FormattedMessage id="ListingPage.safetyMeasures" />
                          </div>
                          {/* <div className={css.riskDesc}>{m.desc[userNativeLang]}</div> */}
                          <div className={css.riskDesc}>
                            {listingRiskFactors?.filter(f => f?.key === m?.key).map(m => m?.value)}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : null}
              <div className={css.footerDiv}>
                <div className={css.IdDiv}>
                  <FormattedMessage id="SearchPage.gigId" />{' '}
                  <span>
                    {' '}
                    {currentListing?.attributes?.publicData?.gigId
                      ? currentListing?.attributes?.publicData?.gigId
                      : 'G - 123456'}
                  </span>
                </div>
                <span className={css.dash}>
                  {!!publishedDate && publishedDate !== undefined ? ` - ` : null}
                </span>

                {!!publishedDate && publishedDate !== undefined ? (
                  <div className={css.publicationDiv}>
                    <FormattedMessage id="SearchPage.Dateofpublication" />{' '}
                    <span>{moment(publishedDate).format('DD/MM/YY')}</span>
                  </div>
                ) : null}
              </div>
            </div>

            <Modal
              id="ListingPage.enquiry"
              contentClassName={css.enquiryModalContent}
              isOpen={isAuthenticated && this.state.enquiryModalOpen}
              onClose={() => this.setState({ enquiryModalOpen: false })}
              onManageDisableScrolling={onManageDisableScrolling}
            >
              <EnquiryForm
                className={css.enquiryForm}
                submitButtonWrapperClassName={css.enquirySubmitButtonWrapper}
                listingTitle={title}
                authorDisplayName={authorDisplayName}
                sendEnquiryError={sendEnquiryError}
                onSubmit={this.onSubmitEnquiry}
                inProgress={sendEnquiryInProgress}
              />
            </Modal>
            <Modal
              id="Listingpage.closeListing"
              isOpen={this.state.showClosedModal}
              onClose={() => this.setShowCloseModal(false)}
              onManageDisableScrolling={onManageDisableScrolling}
              usePortal
              className={css.BlockModal}
              showCloseButton={false}
            >
              <div className={css.gigCloseContainer}>
                <h3>
                  <FormattedMessage id="ManageListingCard.closeListing.title" />
                </h3>
                <p>
                  <FormattedMessage id="ManageListingCard.closeListing.msg" />
                </p>

                {closingListingError ? (
                  <p className={css.error}>
                    {closingListingError.error?.message?.[userNativeLang] || (
                      <FormattedMessage id="ManageListingCard.closeListing.failed" />
                    )}
                  </p>
                ) : null}
                <div className={css.actionButtonContainer}>
                  <PrimaryButton
                    onClick={this.acceptListingClose}
                    inProgress={closeListingInProgress}
                  >
                    <FormattedMessage id="ManageListingCard.closeListing.yes" />
                  </PrimaryButton>
                  <PrimaryButton onClick={() => this.setShowCloseModal(false)}>
                    <FormattedMessage id="ManageListingCard.closeListing.no" />
                  </PrimaryButton>
                </div>
              </div>
            </Modal>
            <Modal
              id="ListingPage.misAccept"
              contentClassName={css.enquiryModalContent}
              isOpen={isAuthenticated && this.state.misAcceptModal}
              onClose={() => {
                this.setState({
                  misAcceptModal: false,
                  bookingInProgress: false,
                });
              }}
              onManageDisableScrolling={onManageDisableScrolling}
              containerClassName={css.invoiceModal}
            >
              <div className={css.appliedModalDiv}>
                <div className={css.modalTitle}>
                  <FormattedMessage id="ListingPage.misAcceptModalTitle" />
                </div>
                <div className={css.modalDesc}>
                  <FormattedMessage id="ListingPage.misAcceptModalDesc" />
                </div>

                <Button
                  type="button"
                  className={css.submitButton}
                  onClick={() =>
                    this.setState({
                      misAcceptModal: false,
                      bookingInProgress: false,
                    })
                  }
                >
                  <FormattedMessage id="ContactDetailsForm.TurnOnAuth" />
                </Button>
              </div>
            </Modal>
            <Modal
              id="ListingPage.cancelBooking"
              contentClassName={css.enquiryModalContent}
              isOpen={isAuthenticated && this.state.cancelBooking}
              onClose={() => {
                this.setState({
                  cancelBooking: false,
                  bookingInProgress: false,
                });
              }}
              onManageDisableScrolling={onManageDisableScrolling}
              containerClassName={css.invoiceModal}
            >
              <div className={css.appliedModalDiv}>
                <div className={css.modalTitle}>
                  <FormattedMessage id="ListingPage.cancelBookingTitle" />
                </div>
                <div className={css.modalDesc}>
                  <FormattedMessage id="ListingPage.cancelBookingDesc" />
                </div>

                <Button
                  type="button"
                  className={css.submitButton}
                  onClick={() => this.handleCancel()}
                  inProgress={this.state.cancelLoading}
                >
                  <FormattedMessage id="ContactDetailsForm.TurnOnAuth" />
                </Button>
                <Button
                  type="button"
                  className={`${css.cancelBtn} ${css.submitButton}`}
                  onClick={() => this.setState({ cancelBooking: false })}
                >
                  <FormattedMessage id="FieldBoolean.no" />
                </Button>
              </div>
            </Modal>
            <Modal
              id="ListingPage.vacancyfull"
              contentClassName={css.enquiryModalContent}
              isOpen={isAuthenticated && this.state.vacancyFullModal}
              onClose={() => {
                this.setState({
                  vacancyFullModal: false,
                  bookingInProgress: false,
                });
              }}
              onManageDisableScrolling={onManageDisableScrolling}
              containerClassName={css.invoiceModal}
            >
              <div className={css.appliedModalDiv}>
                <div className={css.modalTitle}>
                  <FormattedMessage id="ListingPage.vancancyModalTitle" />
                </div>
                <div className={css.modalDesc}>
                  <FormattedMessage id={this.state.vacanyFullMsgId} />
                </div>

                <Button
                  type="button"
                  className={css.submitButton}
                  onClick={() =>
                    this.setState({
                      vacancyFullModal: false,
                      bookingInProgress: false,
                    })
                  }
                >
                  <FormattedMessage id="ContactDetailsForm.TurnOnAuth" />
                </Button>
              </div>
            </Modal>
            <Modal
              id="ListingPage.noBankDetails"
              contentClassName={css.enquiryModalContent}
              isOpen={isAuthenticated && this.state.noBankDetailsModal}
              onClose={() => {
                this.setState({
                  noBankDetailsModal: false,
                });
              }}
              onManageDisableScrolling={onManageDisableScrolling}
              containerClassName={classNames(css.invoiceModal, css.noBankDetailModal)}
            >
              <div className={css.appliedModalDiv}>
                <div className={css.modalTitle}>
                  <FormattedMessage id="ListingPage.noBankDetailsModalTitle" />
                </div>
                <div className={css.modalDesc}>
                  <FormattedMessage id="ListingPage.noBankDetailsModalModalDesc" />
                </div>

                <InlineTextButton
                  type="button"
                  className={css.addBookingDetaisBtn}
                  onClick={this.goToPayoutPage}
                >
                  <FormattedMessage id="ListingPage.addBankDetailsBtn" />
                </InlineTextButton>
              </div>
            </Modal>
            {/* <Modal
              id="ListingPage.tnq"
              contentClassName={css.enquiryModalContent}
              isOpen={isAuthenticated && this.state.bookingCompleteModalOpen}
              onClose={() => {
                this.setState({
                  bookingCompleteModalOpen: false,
                  bookingInProgress: false,
                });
              }}
              onManageDisableScrolling={onManageDisableScrolling}
              containerClassName={css.invoiceModal}
            >
              <div className={css.appliedModalDiv}>
                <div className={css.modalTitle}>
                  <FormattedMessage id="ListingPage.appliedTitle" />
                </div>
                <div className={css.modalDesc}>
                  <FormattedMessage id="ListingPage.appliedModalDesc" values={{ gigId }} />
                </div>

                <Button
                  type="button"
                  className={css.submitButton}
                  onClick={() => {
                    this.setState({
                      bookingCompleteModalOpen: false,
                      bookingInProgress: false,
                      alreadyApplied: true,
                    });
                  }}
                >
                  <FormattedMessage id="ContactDetailsForm.TurnOnAuth" />
                </Button>
              </div>
            </Modal> */}
          </LayoutWrapperMain>

          <LayoutWrapperFooter>
            <Footer />
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }
}

ListingPageComponent.defaultProps = {
  unitType: config.bookingUnitType,
  currentUser: null,
  enquiryModalOpenForListingId: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  monthlyTimeSlots: null,
  sendEnquiryError: null,
  filterConfig: config.custom.filters,
  lineItems: null,
  fetchLineItemsError: null,
};

ListingPageComponent.propTypes = {
  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string,
  }).isRequired,

  unitType: propTypes.bookingUnitType,
  // from injectIntl
  intl: intlShape.isRequired,

  params: shape({
    id: string.isRequired,
    slug: string,
    variant: oneOf([LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT]),
  }).isRequired,

  isAuthenticated: bool.isRequired,
  currentUser: propTypes.currentUser,
  getListing: func.isRequired,
  getOwnListing: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  scrollingDisabled: bool.isRequired,
  enquiryModalOpenForListingId: string,
  showListingError: propTypes.error,
  callSetInitialValues: func.isRequired,
  reviews: arrayOf(propTypes.review),
  fetchReviewsError: propTypes.error,
  monthlyTimeSlots: object,
  // monthlyTimeSlots could be something like:
  // monthlyTimeSlots: {
  //   '2019-11': {
  //     timeSlots: [],
  //     fetchTimeSlotsInProgress: false,
  //     fetchTimeSlotsError: null,
  //   }
  // }
  sendEnquiryInProgress: bool.isRequired,
  sendEnquiryError: propTypes.error,
  onSendEnquiry: func.isRequired,
  onInitializeCardPaymentData: func.isRequired,
  filterConfig: array,
  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.Auth;
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    sendEnquiryInProgress,
    sendEnquiryError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    enquiryModalOpenForListingId,
    listingTransactionId,
    assignedStatus,
    listingUserTx,
    applyButtonsReady,
    assignButtonsReady,
    workerBlockedTimeslots,
  } = state.ListingPage;
  const {
    fetchStripeAccountError,
    stripeAccount,
    stripeAccountFetched,
  } = state.stripeConnectAccount;
  const { isWorkerBlocked } = state.WorkerProfileAdminViewPage;
  const {
    closingListing,
    openingListing,
    closingListingError,
    closeListingInProgress,
  } = state.ManageListingsPage;
  const { currentUser } = state.user;
  const { userNativeLang } = state.UI;

  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };
  const btnLoading = !(applyButtonsReady && assignButtonsReady);
  return {
    isAuthenticated,
    listingUserTx,
    currentUser,
    getListing,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    enquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    sendEnquiryInProgress,
    sendEnquiryError,
    userNativeLang,
    closingListing,
    openingListing,
    listingTransactionId,
    assignedStatus,
    isWorkerBlocked,
    stripeAccount,
    btnLoading,
    closingListingError,
    closeListingInProgress,
    workerBlockedTimeslots,
  };
};

const mapDispatchToProps = dispatch => ({
  onCloseListing: listingId => dispatch(closeListing(listingId)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
  onFetchTransactionLineItems: (bookingData, listingId, isOwnListing) =>
    dispatch(fetchTransactionLineItems(bookingData, listingId, isOwnListing)),
  onSendEnquiry: (listingId, message) => dispatch(sendEnquiry(listingId, message)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  onFetchTimeSlots: (listingId, start, end, timeZone) =>
    dispatch(fetchTimeSlots(listingId, start, end, timeZone)),
  onInitiateZeroOrder: orderParams => dispatch(initiateZeroOrder(orderParams)),
  oninitiateAssignedGigs: orderParams => dispatch(initiateAssignedGigs(orderParams)),
  onDeclineAssignedJob: params => dispatch(declineAssignedGigs(params)),
  onUpdateProfile: data => dispatch(updateProfile(data)),
  onCustomUpdateProfile: data => dispatch(customUpdateProfile(data)),
  onFetchTransactionId: listingId => dispatch(fetchTransactionId(listingId)),
  onfetchUserTransaction: listingId => dispatch(fetchUserTransaction(listingId)),
  onResetCloseListingStatus: () => dispatch(resetCloseListingStatus()),
  onRemoveWorker: params => dispatch(removeWorker(params)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ListingPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(ListingPageComponent);

export default ListingPage;
